// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1kz2q","box":"WorkspacesBox_box__2HWqq","node":"WorkspacesBox_node__1qjRf"};